export const PAYFAC_QUERIES = {
  RATE_PLANS: "PAYFAC_RATE_PLANS",
  RATE_PLANS_SELLERS: "PAYFAC_RATE_PLANS_SELLERS",
  RATE_PLANS_HISTORY: "PAYFAC_RATE_PLANS_HISTORY",
  RATE_PLANS_HISTORY_DETAIL: "PAYFAC_RATE_PLANS_HISTORY_DETAIL",
  SELLERS: "PAYFAC_SELLERS",
  SELLER_PLAN: "PAYFAC_SELLER_PLAN",
  SELLER_RATES: "PAYFAC_SELLER_RATES",
  BARTE_TAXES: "PAYFAC_BARTE_TAXES",
  SIGNED_DASHBOARD: "PAYFAC_REPORT_SIGNED_DASHBOARD",
  PENDENCIES: "PAYFAC_PENDENCIES",
  FEATURE_TOGGLES: "PAYFAC_FEATURE_TOGGLES",
} as const;
